module.exports = __webpack_public_path__ + "img/8.fb331739.jpg";